import { isBoolean as c } from "./index66.js";
import { isEmpty as s } from "./index22.js";
import { isNill as p } from "./index67.js";
import { isString as f } from "./index69.js";
function l(r) {
  return m(r, 1);
}
function m(r, a) {
  const i = [];
  return f(r) ? r.trim().split(" ").forEach((t) => {
    const o = t.trim();
    !s(o) && i.push(o);
  }) : Array.isArray(r) ? a < 10 && r.forEach((t) => {
    const o = m(t, a + 1);
    !s(o) && i.push(o);
  }) : !p(r) && !c(r) && Object.keys(r).forEach((t) => {
    r[t] && t.trim().split(" ").forEach((o) => {
      const n = o.trim();
      !s(n) && i.push(n);
    });
  }), i.join(" ");
}
export {
  l as parseClassNames
};
